import React, { useState, useEffect } from "react";
import "./style.scss";
import Heading from "../../elements/heading";
import Input from "../../elements/input";
import Checkbox from "../../elements/checkbox";
import PrimaryButton from "../../elements/primary-button";
import SimpleLink from "../../elements/simple-link";
import BodyText from "../../elements/body-text";
import InputPhoneNumber from "../../elements/InputPhoneNumber";
import PropTypes from "prop-types";
import Dropdown from "../../elements/dropdown";

import { scrollToSmooth } from "../../hooks/scrollToSmooth.js";
import getSiteInfo from "../../utils/getSiteInfo";
import { isBizNull } from "../../utils";
import { getCountryOptions } from "../../services/siteService";
import { S_LANG, webStorage } from "../../utils/webStorage";
let errorScrollTimeout;

const CreateAccountForm = ({
  formTitleType,
  formTitleBody,
  emailLabel,
  emailInfoText,
  emailWarningMessage,
  emailMissingMessage,
  passwordLabel,
  passwordInfoText,
  passwordWarningMessage,
  passwordMissingMessage,
  personalInfoTitleType,
  personalInfoTitleBody,
  firstNameLabel,
  firstNameInfoText,
  firstNameWarningMessage,
  firstNameMissingMessage,
  lastNameLabel,
  lastNameInfoText,
  lastNameWarningMessage,
  lastNameMissingMessage,
  phoneAreaLabel,
  phoneAreaInfoText,
  phoneLabel,
  phoneInfoText,
  phoneWarningMessage,
  phoneMissingMessage,
  phoneExixtsMessage,
  registrationInProcessMessage,
  dateOfBirthLabel,
  dateOfBirthInfoText,
  dateOfBirthWarningMessage,
  dateOfBirthUnder18Message,
  countryLabel,
  countryWarningMessage,
  newsletterCheckboxLabel,
  newsletterCheckboxBody,
  termsAndConditionsCheckboxLabel,
  termsAndConditionsCheckboxBody,
  createAccountFailedMessage,
  loginNetworkErrorMessage,
  accountExistsMessage,
  backToLogin,
  submitCreateAccount,
  createAccountFailed,
  isNetworkFailed,
  accountExists,
  phoneExists,
  registrationInProcess,
  ctaName,
  colorScheme,
  iconName,
  disclaimerText,
  submitting,
  preFilledData,
  newValueToParent = () => {}
}) => {
  const lang = webStorage.get(S_LANG);
  const [formDataEmail, setEmail] = useState(preFilledData?.email);
  const [formDataPassword, setPassword] = useState(preFilledData?.password);
  const [formDataFirstname, setFirstname] = useState(preFilledData?.firstName);
  const [formDataLastname, setLastname] = useState(preFilledData?.lastName);
  const [formDataPhoneArea, setPhoneArea] = useState(preFilledData?.mobileCountryCode);
  const [formDataPhone, setPhone] = useState(preFilledData?.mobileNo);
  const [phoneIsValid, setPhoneIsValid] = useState(true);
  const [submitTimestamp, setSubmitTimestamp] = useState();
  const [countryVisible, setCountryVisible] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [formDataCountry, setCountry] = useState(null);
  const [formDataDateOfBirth, setDateOfBirth] = useState(preFilledData?.birthday);
  const [formDataNewsletter, setNesletterPreference] = useState(preFilledData?.subscribed);
  const [formDataAgreedToTerms, setAgreeToTerms] = useState(preFilledData?.agreedToTerms);

  //mandatory fields
  const [emailError, setEmailError] = useState();
  const [passwordError, setPasswordError] = useState();
  const [firstnameError, setFirstnameError] = useState();
  const [lastnameError, setLastnameError] = useState();
  const [dateOfBirthError, setDateOfBirthError] = useState();
  const [phoneAreaError, setPhoneAreaError] = useState();
  const [phoneError, setPhoneError] = useState();
  const [countryError, setCountryError] = useState();
  const [agreedToTermsHasError, setAgreedToTermsHasError] = useState();

  // inside input validation errors
  const [emailHasValidationError, setEmailHasValidationError] = useState();
  const [passwordHasValidationError, setPasswordHasValidationError] = useState(false);
  const [dateOfBirthHasValidationError, setDateOfBirthHasValidationError] = useState(false);
  const [dateOfBirthUnder18, setDateOfBirthUnder18] = useState(false);

  useEffect(() => {
    if (!isBizNull(preFilledData)) {
      setEmail(preFilledData.email);
      setPassword(preFilledData.password);
      setFirstname(preFilledData.firstName);
      setLastname(preFilledData.lastName);
      setPhoneArea(preFilledData.mobileCountryCode);
      setPhone(preFilledData.mobileNo);
      setDateOfBirth(preFilledData.birthday);
      setNesletterPreference(preFilledData.subscribed);
      setAgreeToTerms(preFilledData.agreedToTerms);
    }
  }, [preFilledData]);
  useEffect(() => {
    if (lang.search("-") === -1) {
      setCountryVisible(true);
      getCountryOptions().then(options => {
        setCountryList(options);
      });
    } else {
      setCountryVisible(false);
      setCountryList([]);
      getSiteInfo().then(res => {
        setCountry({
          code: res.country
        });
      });
    }
  }, [lang]);
  useEffect(() => {
    if (countryList.length > 0 && preFilledData) {
      const country = countryList.find(x => x.code === preFilledData.country?.code);
      setCountry(country);
    }
  }, [preFilledData, countryList]);

  const handleSetValue = () => {
    if (formDataEmail !== null || formDataPassword !== null || formDataFirstname !== null || formDataLastname !== null || formDataPhoneArea !== null || formDataPhone !== null || formDataCountry !== null || formDataDateOfBirth !== null) {
      setHasValue(true);
    } else {
      setHasValue(false);
    }
  };
  const setHasValue = value => {
    newValueToParent(value);
  };

  const onEmailBlur = (evt, isValid) => {
    setEmail(evt.target.value);
    handleSetValue();

    if (evt.target.value) {
      setEmailHasValidationError(!isValid);
    } else {
      setEmailHasValidationError(false);
    }
  };

  const onPasswordBlur = (evt, isValid) => {
    setPassword(evt.target.value);
    handleSetValue();

    if (evt.target.value) {
      setPasswordHasValidationError(!isValid);
    } else {
      setPasswordHasValidationError(false);
    }
  };
  const onFirstnameBlur = evt => {
    setFirstname(evt.target.value);
    handleSetValue();
  };
  const onLastnameBlur = evt => {
    setLastname(evt.target.value);
    handleSetValue();
  };

  const onPhoneChange = (area, number, isValid) => {
    setPhoneArea(area);
    setPhone(number);
    setPhoneIsValid(isValid);
  };

  const onCountryChange = option => {
    setCountry(option);
    handleSetValue();
  };
  const onDateOfBirthBlur = (evt, isValid, isOver18) => {
    setDateOfBirth(evt.target.value);
    handleSetValue();

    setDateOfBirthHasValidationError(evt.target.value && !isValid);
    setDateOfBirthUnder18(evt.target.value && evt.target.value != "" && !isOver18);
  };
  const onNesletterPreferenceChanged = (checked, evt) => {
    setNesletterPreference(checked);
    handleSetValue();
  };
  const onAgreeToTermsChanged = (checked, evt) => {
    setAgreeToTerms(checked);
    setAgreedToTermsHasError(false);
    handleSetValue();
  };

  const onEmailHasFocus = () => {
    setEmailError(null);
  };
  const onPasswordHasFocus = () => {
    setPasswordError(null);
  };
  const onFirstnameHasFocus = () => {
    setFirstnameError(null);
  };
  const onLastnameHasFocus = () => {
    setLastnameError(null);
  };
  const onPhoneAreaHasFocus = () => {
    setPhoneAreaError(null);
  };
  const onPhoneHasFocus = () => {
    setPhoneError(null);
  };
  const onCountryHasFocus = () => {
    setCountryError(null);
  };

  const dataIsValidToSubmit = () => {
    let valid = true;
    if (!formDataEmail) {
      setEmailError(emailMissingMessage.value);
      valid = false;
    } else if (emailHasValidationError) {
      setEmailError(emailWarningMessage.value);
      valid = false;
    }
    if (!formDataPassword) {
      setPasswordError(passwordMissingMessage.value);
      valid = false;
    } else if (passwordHasValidationError) {
      setPasswordError(passwordWarningMessage.value);
      valid = false;
    }
    if (!formDataFirstname) {
      setFirstnameError(firstNameMissingMessage.value);
      valid = false;
    }
    if (!formDataLastname) {
      setLastnameError(lastNameMissingMessage.value);
      valid = false;
    }
    if (!!formDataDateOfBirth) {
      if (dateOfBirthHasValidationError) {
        setDateOfBirthError(dateOfBirthWarningMessage.value);
        valid = false;
      }
      if (dateOfBirthUnder18) {
        setDateOfBirthError(dateOfBirthUnder18Message.value);
        valid = false;
      }
    }
    if (!phoneIsValid) {
      valid = false;
    }

    if (!formDataPhone) {
      valid = false;
    }

    if (countryLabel.value && !formDataCountry) {
      setCountryError(countryWarningMessage.value);
      valid = false;
    }
    if (formDataCountry.code === "default") {
      setCountryError(countryWarningMessage.value);
      valid = false;
    }
    if (!formDataAgreedToTerms) {
      setAgreedToTermsHasError(true);
      valid = false;
    }
    return valid;
  };

  const onSubmit = evt => {
    setSubmitTimestamp(new Date());
    evt.preventDefault();
    const errorElement = document.querySelector(".show-warning");
    let isValid = errorElement ? false : dataIsValidToSubmit();
    const formData = {
      email: formDataEmail,
      password: formDataPassword,
      firstName: formDataFirstname,
      lastName: formDataLastname,
      mobileCountryCode: formDataPhoneArea,
      mobileNo: formDataPhone,
      country: formDataCountry,
      birthday: formDataDateOfBirth,
      subscribed: formDataNewsletter,
      agreedToTerms: formDataAgreedToTerms
    };
    if (isValid) {
      submitCreateAccount(evt, formData);
      /** Measurement */
      let dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "accountCreate",
        eventCategory: "account",
        eventAction: "create",
        eventLabel: "Level0"
      });
    } else {
      evt.target.focus();
      if (errorScrollTimeout) {
        clearTimeout(errorScrollTimeout);
      }
      errorScrollTimeout = setTimeout(function() {
        const errorElement = document.querySelector(".show-warning");
        if (errorElement) {
          scrollToSmooth(errorElement);
        }
      }, 100);
    }
  };
  return (
    <form className={"create-account-form"} autoComplete="on">
      {formTitleBody && <Heading type={formTitleType} className={"title"} html={formTitleBody} typographyClass={"type-h3"} />}
      {emailLabel && (
        <Input
          {...{
            autocomplete: "email",
            name: "email",
            label: emailLabel.value,
            value: formDataEmail,
            infoMessage: emailInfoText.value,
            warningMessage: emailError,
            type: "email",
            showError: !!emailError,
            preventScroll: true,
            onBlur: (evt, isValid) => onEmailBlur(evt, isValid),
            onFocus: onEmailHasFocus
          }}
        />
      )}

      {passwordLabel && (
        <Input
          {...{
            autocomplete: "new-password",
            name: "password",
            label: passwordLabel.value,
            value: formDataPassword,
            infoMessage: passwordInfoText.value,
            warningMessage: passwordError,
            type: "password",
            showError: !!passwordError,
            preventScroll: true,
            onBlur: (evt, isValid) => onPasswordBlur(evt, isValid),
            onFocus: onPasswordHasFocus
          }}
        />
      )}

      {personalInfoTitleBody && <Heading type={personalInfoTitleType} className={"title last show-on-scroll"} html={personalInfoTitleBody} typographyClass={"type-h3"} />}

      {firstNameLabel && (
        <Input
          {...{
            name: "first-name",
            autocomplete: "first-name",
            label: firstNameLabel.value,
            value: formDataFirstname,
            maxLength: 25,
            infoMessage: firstNameInfoText.value,
            warningMessage: firstnameError,
            showError: !!firstnameError,
            preventScroll: true,
            onFocus: onFirstnameHasFocus,
            onBlur: evt => onFirstnameBlur(evt)
          }}
        />
      )}

      {lastNameLabel && (
        <Input
          {...{
            name: "family-name",
            autocomplete: "family-name",
            label: lastNameLabel.value,
            value: formDataLastname,
            maxLength: 25,
            infoMessage: lastNameInfoText.value,
            warningMessage: lastnameError,
            showError: !!lastnameError,
            preventScroll: true,
            onFocus: onLastnameHasFocus,
            onBlur: evt => onLastnameBlur(evt)
          }}
        />
      )}

      {dateOfBirthLabel && (
        <Input
          {...{
            label: dateOfBirthLabel.value,
            value: formDataDateOfBirth,
            infoMessage: dateOfBirthInfoText.value,
            showError: !!dateOfBirthError,
            warningMessage: dateOfBirthError,
            type: "dateOfBirth",
            preventScroll: true,
            onBlur: (evt, isValid, isOver18) => onDateOfBirthBlur(evt, isValid, isOver18)
          }}
        />
      )}

      {countryVisible && countryLabel.value && (
        <Dropdown
          {...{
            placeholder: countryLabel.value,
            warningMessage: countryError,
            enableFilter: true,
            options: countryList,
            selectedOption: formDataCountry,
            showError: !!countryError,
            preventScroll: true,
            onFocus: onCountryHasFocus,
            onChange: option => onCountryChange(option)
          }}
        />
      )}

      {phoneAreaLabel && phoneLabel && (
        <InputPhoneNumber
          phoneArea={{
            label: phoneAreaLabel.value,
            value: formDataPhoneArea
          }}
          phoneNumber={{
            label: phoneLabel.value,
            value: formDataPhone
          }}
          infoMessage={phoneInfoText.value}
          warningMessage={phoneWarningMessage.value}
          missingMessage={phoneMissingMessage.value}
          onChange={(area, number, isValid) => {
            onPhoneChange(area, number, isValid);
          }}
          onInit={(area, number, isValid) => {
            onPhoneChange(area, number, isValid);
          }}
          submitTimestamp={submitTimestamp}
        />
      )}

      {newsletterCheckboxLabel && (
        <Checkbox
          {...{
            label: newsletterCheckboxLabel.value,
            infoText: newsletterCheckboxBody.value,
            checked: formDataNewsletter,
            preventScroll: true,
            onChange: onNesletterPreferenceChanged
          }}
        />
      )}

      {termsAndConditionsCheckboxLabel && (
        <Checkbox
          {...{
            label: termsAndConditionsCheckboxLabel.value,
            infoText: termsAndConditionsCheckboxBody.value,
            error: agreedToTermsHasError,
            checked: formDataAgreedToTerms,
            preventScroll: true,
            onChange: onAgreeToTermsChanged
          }}
        />
      )}

      {createAccountFailed && createAccountFailedMessage && <span className="failed-message">{createAccountFailedMessage.value}</span>}
      {isNetworkFailed && loginNetworkErrorMessage && <span className="failed-message">{loginNetworkErrorMessage.value}</span>}
      {accountExists && accountExistsMessage && <span className="failed-message">{accountExistsMessage.value}</span>}
      {phoneExists && phoneExixtsMessage && <span className="failed-message">{phoneExixtsMessage.value}</span>}
      {registrationInProcess && <span className="failed-message">{registrationInProcessMessage.value}</span>}
      <div className={"button-container"}>
        {ctaName && (
          <PrimaryButton
            {...{
              colorScheme: colorScheme,
              iconName: iconName,
              isDisabled: submitting,
              link: {
                value: {
                  text: ctaName.value
                }
              },
              callback: evt => onSubmit(evt)
            }}
          />
        )}

        {backToLogin && <SimpleLink {...backToLogin.value} />}
      </div>

      {disclaimerText && (
        <div className={"info-background"}>
          <BodyText className="disclaimer" html={disclaimerText.value} />
        </div>
      )}
    </form>
  );
};

CreateAccountForm.propTypes = {
  formTitleType: PropTypes.object,
  formTitleBody: PropTypes.object,
  emailLabel: PropTypes.shape({ value: PropTypes.string }),
  emailInfoText: PropTypes.shape({ value: PropTypes.string }),
  emailWarningMessage: PropTypes.shape({ value: PropTypes.string }),
  passwordLabel: PropTypes.shape({ value: PropTypes.string }),
  passwordInfoText: PropTypes.shape({ value: PropTypes.string }),
  passwordWarningMessage: PropTypes.shape({ value: PropTypes.string }),
  personalInfoTitleType: PropTypes.object,
  personalInfoTitleBody: PropTypes.object,
  firstNameLabel: PropTypes.shape({ value: PropTypes.string }),
  firstNameInfoText: PropTypes.shape({ value: PropTypes.string }),
  firstNameWarningMessage: PropTypes.shape({ value: PropTypes.string }),
  lastNameLabel: PropTypes.shape({ value: PropTypes.string }),
  lastNameInfoText: PropTypes.shape({ value: PropTypes.string }),
  lastNameWarningMessage: PropTypes.shape({ value: PropTypes.string }),
  dateOfBirthLabel: PropTypes.shape({ value: PropTypes.string }),
  dateOfBirthInfoText: PropTypes.shape({ value: PropTypes.string }),
  dateOfBirthWarningMessage: PropTypes.shape({ value: PropTypes.string }),
  countryLabel: PropTypes.shape({ value: PropTypes.string }),
  countryWarningMessage: PropTypes.shape({ value: PropTypes.string }),
  newsletterCheckboxLabel: PropTypes.object,
  newsletterCheckboxBody: PropTypes.object,
  termsAndConditionsCheckboxLabel: PropTypes.object,
  termsAndConditionsCheckboxBody: PropTypes.object,
  createAccountFailedMessage: PropTypes.object,
  backToLogin: PropTypes.object,
  phoneLabel: PropTypes.shape({ value: PropTypes.string }),
  phoneInfoText: PropTypes.shape({ value: PropTypes.string }),
  phoneAreaLabel: PropTypes.shape({ value: PropTypes.string }),
  phoneAreaInfoText: PropTypes.shape({ value: PropTypes.string }),
  phoneWarningMessage: PropTypes.shape({ value: PropTypes.string }),
  phoneMissingMessage: PropTypes.shape({ value: PropTypes.string }),
  submitCreateAccount: PropTypes.func,
  createAccountFailed: PropTypes.bool,
  ctaName: PropTypes.object,
  colorScheme: PropTypes.object,
  iconName: PropTypes.object,
  disclaimerText: PropTypes.shape({ value: PropTypes.string }),
  newValueToParent: PropTypes.func
};

CreateAccountForm.defaultProps = {
  submitCreateAccount: () => {}
};

export default CreateAccountForm;
